import { api } from "./api";

export interface Patrulha {
  id: string;
  id_oficial: string;
  oficial: {
    id: string;
    nick: string;
    patente: {
      id: string;
      patente: string;
      abreviacao: string;
    };
  };
  id_patrulheiro: string;
  patrulheiro: {
    id: string;
    nick: string;
    patente: {
      id: string;
      patente: string;
      abreviacao: string;
    };
  };
  inicio: string;
  termino?: string | null;
  trouxe: string;
  status: string;
  criado_em: string;
  alterado_em: string;
}

export interface CreatePatrulhaDTO {
  id_oficial: string;
  id_patrulheiro: string;
  inicio: string;
  status?: string;
}

export interface UpdatePatrulhaStatusDTO {
  status: string;
  termino?: string;
  trouxe?: string;
}

export const patrulhasService = {
  async list(): Promise<Patrulha[]> {
    const response = await api.get("/patrulhas");
    return Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
  },

  async create(data: CreatePatrulhaDTO): Promise<Patrulha> {
    const response = await api.post("/patrulhas", data);
    return response.data;
  },

  async updateStatus(id: string, data: UpdatePatrulhaStatusDTO): Promise<Patrulha> {
    const response = await api.patch(`/patrulhas/${id}/status`, data);
    return response.data;
  },
};
